import React, { useMemo } from 'react'
import { groupBy, keys } from 'lodash'

import SelectDropdown from 'components/SelectDropdown'
import { useColorSetting } from 'flow/settings/color'
import { useIntl } from 'react-intl'

const customTheme = ({ projectTheme, menuIsOpen }) => ({
  control: {
    background: menuIsOpen ? projectTheme.white : projectTheme.blueDark
  }
})

const menuOrder = [
  'Learning Map',
  'User Data',
  ''
]

const SelectColors = () => {
  const [selectedColor, colors, setColor] = useColorSetting()
  const wording = useIntl()
  // forge grouped options
  const groupedOptions = useMemo(() => {
    const groups = groupBy(colors, 'group')
    return keys(groups).map(groupLabel => {
      const group = groups[groupLabel].map((d) => {
        return {
          ...d,
          tooltip: wording.messages[`tooltip-${d.value}`]
        }
      })

      return {
        label: groupLabel,
        options: group
      }
    }).sort((a, b) => {
      return menuOrder.indexOf(a.label) - menuOrder.indexOf(b.label)
    })
  }, [colors, wording.messages])

  return (
    <SelectDropdown
      options={groupedOptions}
      selected={selectedColor}
      onChange={setColor}
      customTheme={customTheme}
    />

  )
}

export default SelectColors
